<template>
    <div class="container">
        <hr style="width:70%" class="mx-auto">
        <h7><strong> <i>Sección administrativa del software de cotización </i> </strong></h7>
    </div>
</template>